import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import isGHMC, {
  formatDateTimeWithoutSec,
  formattedDate,
  getCurrentDateTime,
} from "../../../../Common/helper/helpar";
import MSWManagementSecondaryCollectionStore from "./store/MSWManagementSecondaryCollectionStore";
import Loader from "../../../../Common/Loader/loader";
import MUITable from "../../../../Common/MUITable";
import { MSWDeployedVehiclesInnerExport } from "./MSWDeployedVehiclesInnerExport";
// import { MSWManagementVehiclesInnerExport } from "./MSWManagementVehiclesInnerExport";

export const DeployedVehiclesInnerReport = () => {
  const {
    setkpi5outerData,
    kpi5outerData,
    fetchMSWDepolyedInnerReport,
    MSWDepolyedData,
    IsMSWDepolyed,
  } = MSWManagementSecondaryCollectionStore();
  console.log("kpi5outerData", kpi5outerData);
  const isProd = isGHMC();
  const navigate = useNavigate();

  useEffect(() => {
    deployedDataFetch();
  }, []);
   const formattedDateForBE = (dateString) => {
  const dateOnly = dateString?.split('T')[0];
  const [year, month, day] = dateOnly?.split('-');
  return `${year}-${month}-${day}`;
};

  const formattedDateForBENew = (dateString) => {
  const dateOnly = dateString?.split('T')[0];
  const [year, month, day] = dateOnly?.split('-');
  return `${day}-${month}-${year}`;
};

  /* ================= TABLE COLUMNS ================= */
  const DeployedVehiclesInnerReportColumns = [
   
    {
      label: "Zone Name",
      field: "zoneName",
    //   render: (row) => (
    //     <div
    //       style={{ fontWeight: row.zoneName === "Total" ? "bold" : "normal" }}
    //     >
    //       {row.zoneName}
    //     </div>
    //   ),
    },
    {
      label: "Circle Name",
      field: "circleName",
    //   render: (row) => (
    //     <div
    //       style={{ fontWeight: row.circleName === "Total" ? "bold" : "normal" }}
    //     >
    //       {row.circleName}
    //     </div>
    //   ),
    },
    {
      label: "Ward",
      field: "wardName",
    //   render: (row) => (
    //     <div
    //       style={{ fontWeight: row.wardName === "Total" ? "bold" : "normal" }}
    //     >
    //       {row.wardName}
    //     </div>
    //   ),
    },
    {
      label: "Vehicle Type",
      field: "vehicleTypeName",
    //   render: (row) => (
    //     <div
    //       style={{ fontWeight: row.vehicleTypeName === "Total" ? "bold" : "normal" }}
    //     >
    //       {row.vehicleTypeName}
    //     </div>
    //   ),
    },
    {
      label: "Owner Type",
      field: "ownerTypeName",
    //   render: (row) => (
    //     <div
    //       style={{ fontWeight: row.ownerTypeName === "Total" ? "bold" : "normal" }}
    //     >
    //       {row.ownerTypeName}
    //     </div>
    //   ),
    },
    {
      label: "Vehicle Capacity",
      field: "vehicleCapacityName",
    //   render: (row) => (
    //     <div
    //       style={{ fontWeight: row.vehicleCapacityName === "Total" ? "bold" : "normal" }}
    //     >
    //       {row.vehicleCapacityName}
    //     </div>
    //   ),
    },
    {
      label: "Vehicle Number",
      field: "vehicleNumber",
    //   render: (row) => (
    //     <div
    //       style={{ fontWeight: row.vehicleNumber === "Total" ? "bold" : "normal" }}
    //     >
    //       {row.vehicleNumber}
    //     </div>
    //   ),
    },
    {
      label: "Scanned Date",
      field: "deploymentDate",
      render: (row) => (
        <div
          style={{ fontWeight: row.deploymentDate === "Total" ? "bold" : "normal" }}
        >
          {formattedDateForBENew(row.deploymentDate)}
        </div>
      ),
    },
    {
      label: "Latitude",
      field: "scannedLatitude",
    //   render: (row) => (
    //     <div
    //       style={{ fontWeight: row.scannedLatitude === "Total" ? "bold" : "normal" }}
    //     >
    //       {row.scannedLatitude}
    //     </div>
    //   ),
    },
    {
      label: "Longitude",
      field: "scannedLongitude",
    //   render: (row) => (
    //     <div
    //       style={{ fontWeight: row.scannedLongitude === "Total" ? "bold" : "normal" }}
    //     >
    //       {row.scannedLongitude}
    //     </div>
    //   ),
    },
    {
      label: "Depolyed By",
      field: "deployedBy",
    //   render: (row) => (
    //     <div
    //       style={{ fontWeight: row.ownerTypeName === "Total" ? "bold" : "normal" }}
    //     >
    //       {row.ownerTypeName}
    //     </div>
    //   ),
    },

    {
      label: "Shift",
      field: "shiftName",
    //   render: (row) => (
    //     <div
    //       style={{ fontWeight: row.shiftName === "Total" ? "bold" : "normal" }}
    //     >
    //       {row.shiftName}
    //     </div>
    //   ),
    },
  ];

  const storedFilters = localStorage.getItem("mswSecondaryCollectionFilters");
  const parsedFilters = JSON.parse(storedFilters);

  const storedDate = localStorage.getItem("MSWManagementVehiclesDate");
  const parsedDate = JSON.parse(storedDate);

  console.log(parsedDate);

  const deployedDataFetch = async () => {
    const payload = {
      zoneId: kpi5outerData?.ZoneId,
      circleId: kpi5outerData?.CircleId,
      deploymentDate: parsedDate,
    };
    try {
      const res = await fetchMSWDepolyedInnerReport(payload);
      console.log("res", res);
    } catch (err) {

    }
  };

  

  const currentDate = getCurrentDateTime();

  return (
    <div style={{ width: "100%" }}>
      <div className="content">
        <div className="page-content">
          <div className="d-flex justify-content-end align-items-end mt-3">
            <button
              className="btn btn-secondary me-2"
              onClick={() => {navigate(-1)
                localStorage.removeItem("kpi5-outer-storage")
              }}
            >
              Back
            </button>
            <MSWDeployedVehiclesInnerExport
              fromDate={parsedFilters.FromDate}
              toDate={parsedFilters.ToDate}
              selectedDate={parsedDate}
            />
          </div>

          <div className="card mt-3">
            <div className="card-body">
              <div
                className="top-header p-2"
                style={{
                  backgroundColor: "#D7D7D7",
                  fontWeight: "600",
                  borderBottom: "1px solid #DDDDDD",
                }}
              >
                <span>
                  Deployed Vehicle Detailed report ({formattedDate(parsedDate)})
                  at
                  {formatDateTimeWithoutSec(currentDate)}
                </span>
              </div>

              {IsMSWDepolyed ? (
                <Loader />
              ) : (
                <MUITable
                  needSRNumber
                //   hasTotalRow
                  tableHeight={500}
                  columns={DeployedVehiclesInnerReportColumns}
                  rows={MSWDepolyedData}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
